module.exports = __webpack_public_path__ + "static/media/DOFA PERSONAL DE EMPLEABILIDAD.e407c7b4.xlsx";